import React, { memo, useMemo, useState } from "react";
import { useAnimationFrame } from "../../hooks/use-animation-frame";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const FakeProgress = require("fake-progress");

const ProgressPercentage: React.FC = () => {
    const [percentage, setPercentage] = useState(0);
    const fakeProgress = useMemo(
        () =>
            new FakeProgress({
                timeConstant: 10000,
                autoStart: true,
            }),
        []
    );
    useAnimationFrame(() => {
        setPercentage(Math.floor(fakeProgress.progress * 100));
    });

    return <span data-testid="ProgressPercentage">{percentage}</span>;
};

export default memo(ProgressPercentage);
